import { useState, useEffect, useDeferredValue, memo } from "react";
import { useTranslation } from "react-i18next";
import { TextField } from "@mui/material";
import { useTheme } from "@mui/material/styles";

type Props = Readonly<{
	dataString: string;
	onActionJsonChange: (value: string) => void;
}>;

const MetadataJSONEditor = ({ dataString, onActionJsonChange }: Props) => {
	const theme = useTheme();
	const { t } = useTranslation();

	const [prevDataString, setPrevDataString] = useState(dataString);
	const [jsonData, setJsonData] = useState(dataString);
	const deferredJsonData = useDeferredValue(jsonData);

	if (dataString !== prevDataString) {
		setPrevDataString(dataString);
		setJsonData(dataString);
	}

	useEffect(() => {
		onActionJsonChange(deferredJsonData);
	}, [onActionJsonChange, deferredJsonData]);

	return (
		<TextField
			placeholder="{}"
			label={t("playground.json")}
			fullWidth={true}
			multiline={true}
			value={jsonData}
			onChange={(event) => (setJsonData(event.target.value))}
			style={{ backgroundColor: theme.vars.palette.background.paper }}
		/>
	);
};

export default memo(MetadataJSONEditor);
